// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".setting_list[data-v-e31f4926]{position:absolute;top:38px;left:-23px;z-index:1;padding:5px 0;font-size:16px;font-weight:400;color:rgba(0,0,0,.5);text-align:center;background-color:#fff;box-shadow:0 3px 8px 0 rgba(86,94,172,.2)}.setting_list .setting_item[data-v-e31f4926]{height:30px;line-height:30px;cursor:pointer}.setting_list .setting_item[data-v-e31f4926]:hover{font-weight:700;color:rgba(0,0,0,.8);background-color:#e0e2e9}", ""]);
// Exports
module.exports = exports;
